"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borgia": {
    "72788b50": [{
      "hkey": "fe897bee",
      "slug": "borgia",
      "name": "Borgia",
      "primary": true,
      "skipSearch": false
    }],
    "donnantona": [{
      "hkey": "fe897bee",
      "slug": "borgia",
      "name": "Borgia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0295f65": [{
      "hkey": "fe897bee",
      "slug": "borgia",
      "name": "Borgia",
      "primary": true,
      "skipSearch": false
    }],
    "vallo": [{
      "hkey": "fe897bee",
      "slug": "borgia",
      "name": "Borgia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;